
import JigQuote from '@/components/helper/JigQuote.vue'
import PromptYesNo from '@/components/modals/PromptYesNo.vue'
import { AppConst } from '@/constants'
import { eventBus } from '@/utils/eventBus'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    'prompt-yes-no': PromptYesNo,
    'jig-quote': JigQuote,
  },
})

/**
 * UpgradeModal.vue
 *
 * Modal that promotes upgrading the plan.
 * - Listens on the root-level event bus for open/close events:
 *   AppConst.rootAppEvents.showUpgradeModal / closeUpgradeModal.
 * - Unregisters listeners in beforeDestroy to avoid memory leaks.
 * - Emits 'on-upgrade-modal-close' when user clicks the close button.
 */
export default class UpgradeModalVue extends Vue {
  public $refs!: Vue['$refs'] & {
    upgradeModal: PromptYesNo
  }

  protected mounted() {
    eventBus.$on(this.rootAppEvents.showUpgradeModal, () => {
      this.ShowPrompt()
    })
    eventBus.$on(this.rootAppEvents.closeUpgradeModal, () => {
      this.CloseModal()
    })
  }

  private get rootAppEvents(): any {
    return AppConst.rootAppEvents
  }

  protected beforeDestroy() {
    eventBus.$off(this.rootAppEvents.showUpgradeModal)
    eventBus.$off(this.rootAppEvents.closeUpgradeModal)
  }

  private ShowPrompt() {
    this.$refs.upgradeModal.ShowPrompt()
  }

  private CloseModal() {
    this.$emit('on-upgrade-modal-close')
    this.$refs.upgradeModal.ClosePrompt()
  }
}
